


































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ITaxTagLocation } from "@/models/tax";
import objectHash from "object-hash";
import { CreateElement } from "vue";

type IHashedTaxLocation = ITaxTagLocation & { hash: string };

@Component({
  components: {
    "location-select": () =>
      import("@/components/app/global/tax/locations/locationSelect.vue")
  }
})
export default class TaxLocationsTableView extends Vue {
  // Props
  @Prop({ required: true })
  public readonly data!: ITaxTagLocation[];

  @Prop({ default: true })
  public readonly editable!: boolean;

  // Data

  public currentlyEditing: any = {};

  // Computed

  public get redundantLocationTooltip() {
    return {
      functional: true,
      render: (h: CreateElement) =>
        h("b-tooltip", {
          props: {
            label: this.$t("_sentence.tax.location_redundant_msg"),
            type: "is-warning",
            multilined: true
          },
          scopedSlots: {
            default: () =>
              h("b-icon", {
                class: "has-cursor-help",
                props: {
                  icon: "exclamation-triangle",
                  type: "is-warning",
                  size: "is-small"
                }
              })
          }
        })
    };
  }

  public get hashedLocations() {
    return this.$_.map(this.data, i => ({ ...i, hash: objectHash.sha1(i) }));
  }

  public get orderedLocations() {
    return this.$_.orderBy(
      this.hashedLocations.map(i => ({
        ...i,
        hasSignificance: this.hasSignificance(i)
      })),
      [
        "country.name",
        location => !location.region_id,
        "region.name",
        location => !location.post_code,
        "post_code"
      ],
      ["asc", "desc", "asc", "desc", "asc"]
    );
  }

  public hasSignificance(taxLocation: IHashedTaxLocation) {
    const locationWithHigherSignificance = this.hashedLocations.find(
      location => {
        if (
          location.hash === taxLocation.hash ||
          location.country_id !== taxLocation.country_id
        )
          return false;
        else if (
          !location.region_id &&
          this.$_.isEmpty(location.post_code) &&
          (taxLocation.region_id || !this.$_.isEmpty(taxLocation.post_code))
        )
          return true;
        else if (
          location.region_id &&
          location.region_id === taxLocation.region_id &&
          this.$_.isEmpty(location.post_code) &&
          !this.$_.isEmpty(taxLocation.post_code)
        )
          return true;

        return false;
      }
    );
    return !locationWithHigherSignificance;
  }

  // Methods

  public onRowClick(taxLocation: IHashedTaxLocation) {
    this.$set(this.currentlyEditing, taxLocation.hash, true);
  }

  public unhash(taxLocation: IHashedTaxLocation) {
    return this.$_.omit(taxLocation, ["hash"]);
  }

  public updateLocation({
    oldLocation,
    newLocation
  }: {
    index: number;
    oldLocation: IHashedTaxLocation;
    newLocation: IHashedTaxLocation;
  }) {
    this.$set(this.currentlyEditing, oldLocation.hash as string, false);
    this.$emit("delete", {
      oldLocation: this.unhash(oldLocation),
      hash: oldLocation.hash
    });
    this.$emit("add", this.unhash(newLocation));
  }

  public cancelEdit(taxLocation: IHashedTaxLocation) {
    this.$set(this.currentlyEditing, taxLocation.hash, false);
  }

  public deleteLocation(row: IHashedTaxLocation) {
    this.$emit("delete", {
      taxLocation: this.unhash(row),
      hash: row.hash
    });
  }
}
